export { GlobalStyle } from "config/globalStyles";
export { StoryblokComponents } from "./storyblok";
